import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Card, CardContent, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography, Zoom } from "@mui/material";
import ListaMedicion from './ListaMedicion'
import TabsGeneral from "src/components/Tabs";
import Bloque1 from './components/Bloque1';
import Bloque2 from './components/Bloque2';
import Bloque3 from './components/Bloque3';
import Bloque4 from './components/Bloque4';
import Bloque5 from './components/Bloque5';
import Bloque6 from './components/Bloque6';
// import Bloque7 from './components/Bloque7';
// import Bloque8 from './components/Bloque8';
import ComponenteHTML from '../consulta_ambulatoria/ComponenteHTML';
import Bloque9 from './components/Bloque9';
import Bloque10 from './components/Bloque10';
import axios from 'axios';
import useAuth from 'src/hooks/useAuth';
import useLayoutContext from 'src/hooks/useAuthLayout';
import ListaReceta from './ListaRecetas'
import { useParams } from 'react-router';
import ListaDiagnostico from './ListaDiagnostico'
import { useSnackbar } from 'notistack';
import confirmSweetAlert from 'src/utils/confirm';
import Antecedentes from '../consulta_ambulatoria/Antecedentes';

export default function Index() {
    const { enqueueSnackbar } = useSnackbar()
    const { drawerOpen } = useLayoutContext()
    const { id } = useParams()
    const { user } = useAuth()

    const [text, setText] = useState([{ id: 'motivo', text: '' }])

    const [datosPausa, setDatosPausa] = useState(null)

    const handleChangedTextState = (t, id) => {
        setText(x => x.reduce((arr, item) => {
            arr.push({ ...item, text: item.id === id ? t : item.text })
            return arr
        }, []))
    }

    useEffect(() => {
        console.log(user)
    }, [user])
    useEffect(() => {
        console.log(drawerOpen.item)
        if (drawerOpen.item.datosPausa) {
            setDatosPausa(drawerOpen.item.datosPausa[0].datos)
        } else {
            setDatosPausa(null)
        }
    }, [drawerOpen])
    useEffect(() => {
        console.log(datosPausa)
        console.log(drawerOpen.item.setMostrarPausa)

        if (datosPausa !== null) {

            setText([{ id: 'motivo', text: datosPausa.motivo_consulta }])

            setText1([
                { id: 'anteExamenFisico', label: "Antencedentes", anteExamenFisico: datosPausa.examen_fisico },
                { id: 'avsc', label: 'AV SC', derecho: datosPausa.od_avsc, izquierdo: datosPausa.oi_avsc },
                { id: 'avph', label: 'AV PH', derecho: '', izquierdo: '' },
                { id: 'avcsc', label: 'AV CSC', derecho: '', izquierdo: '' },
                { id: 'avcc', label: 'AV CC', derecho: datosPausa.od_avcc, izquierdo: datosPausa.oi_avcc },
                { id: 'presion', label: '(mmHg)', derecho: datosPausa.od_tension_ocular, izquierdo: datosPausa.oi_tension_ocular },
                { id: 'paquimetria', label: '(µ)', derecho: datosPausa.od_paqui, izquierdo: datosPausa.oi_paqui },
                { id: 'pupilas', label: 'Valoración de Pupilas', derecho: '', izquierdo: '' },
                { id: 'colores', label: 'Visión de Colores', derecho: '', izquierdo: '' },
            ])

            setText2([
                { id: 'autoreflexion', label: "Auto Refracción", labe1: "OD", label2: "OI", tipo1: 'Autoreflexión', tipo2: '', esf1: datosPausa.auto_ref_od_esf, esf2: datosPausa.auto_ref_oi_esf, cil1: datosPausa.auto_ref_od_cil, cil2: datosPausa.auto_ref_oi_cil, x1: datosPausa.auto_ref_od_x, x2: datosPausa.auto_ref_oi_x, rec1: datosPausa.auto_ref_od_rec, rec2: datosPausa.auto_ref_oi_rec, valor: "" },
                { id: 'lejos', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: datosPausa.l_od_esf, esf2: datosPausa.l_oi_esf, cil1: datosPausa.l_od_cil, cil2: datosPausa.l_oi_cil, x1: datosPausa.l_od_x, x2: datosPausa.l_oi_x, rec1: datosPausa.l_od_rec, rec2: datosPausa.l_oi_rec, comentarioLejos: "", valor: datosPausa.refracciones_obs },
                { id: 'add', label: "CERCA ADD", labe1: "OD", label2: "OI", tipo1: 'ADD', tipo2: '', esf1: datosPausa.add_od_esf, esf2: datosPausa.add_oi_esf, cil1: datosPausa.add_od_cil, cil2: datosPausa.add_oi_cil, x1: datosPausa.add_od_x, x2: datosPausa.add_oi_x, rec1: datosPausa.add_od_rec, rec2: datosPausa.add_oi_rec },
                { id: 'cerca', label: `Cerca`, label0: "ADD", labe1: "OD", label2: "OI", tipo1: 'Cerca', tipo2: '', esf1: datosPausa.c_od_esf, esf2: datosPausa.c_oi_esf, cil1: datosPausa.c_od_cil, cil2: datosPausa.c_oi_cil, x1: datosPausa.c_od_x, x2: datosPausa.c_oi_x, rec1: datosPausa.c_od_rec, rec2: datosPausa.c_oi_rec },
                { id: 'mediaDistancia', label: "Media Distancia", labe1: "OD", label2: "OI", tipo1: 'Media Distancia', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
                { id: 'refraccion', label: "Refracción Cicloplégica", labe1: "OD", label2: "OI", tipo1: 'Refracción Cicloplégica', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
                { id: 'gafas', label: "Gafas", labe1: "OD", label2: "OI", tipo1: 'Gafas', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
                { id: 'lentesContacto', label: "Lentes de contaccto", labe1: "OD", label2: "OI", tipo1: 'Lentes de contaccto', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
                { id: 'lejosObjetiva', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: datosPausa.lejosObjetiva_od_esf, esf2: datosPausa.lejosObjetiva_oi_esf, cil1: datosPausa.lejosObjetiva_od_cil, cil2: datosPausa.lejosObjetiva_oi_cil, x1: datosPausa.lejosObjetiva_od_x, x2: datosPausa.lejosObjetiva_oi_x, rec1: datosPausa.lejosObjetiva_od_rec, rec2: datosPausa.lejosObjetiva_oi_rec }
            ])

            setText8([
                { id: 0, titulo: 'Conjuntiva', label: '', izquierdo: datosPausa.bmc_conjuntiva_i, derecho: datosPausa.bmc_conjuntiva_d, valor: "" },
                { id: 1, titulo: 'Córnea', label: '', izquierdo: datosPausa.bmc_cornea_i, derecho: datosPausa.bmc_cornea_d, valor: "" },
                { id: 2, titulo: 'Cámara Anterior', label: '', izquierdo: datosPausa.bmc_corneaAnt_i, derecho: datosPausa.bmc_corneaAnt_d, valor: "" },
                { id: 3, titulo: 'Iris y Pupila', label: '', izquierdo: datosPausa.bmc_irisPup_i, derecho: datosPausa.bmc_irisPup_d, valor: "" },
                { id: 4, titulo: 'Cristalino', label: '', izquierdo: datosPausa.bmc_cristalino_i, derecho: datosPausa.bmc_cristalino_d, valor: "" },
                { id: 5, titulo: 'Vítreo', label: '', izquierdo: datosPausa.bmc_vitrio_i, derecho: datosPausa.bmc_vitrio_d, valor: "" },
            ])

            setText10([
                { id: 1, titulo: 'Papila', label: '', derecho: datosPausa.fond_pupila_od, izquierdo: datosPausa.fond_pupila_oi, valor: "" },
                { id: 2, titulo: 'Vasos Arteriales', label: '', derecho: datosPausa.fond_vasosArt_od, izquierdo: datosPausa.fond_vasosArt_oi, valor: "" },
                { id: 3, titulo: 'Vasos Venosos', label: '', derecho: datosPausa.fond_VasosVen_od, izquierdo: datosPausa.fond_VasosVen_oi, valor: "" },
                { id: 4, titulo: 'Retina', label: '', derecho: datosPausa.fond_retina_od, izquierdo: datosPausa.fond_retina_oi, valor: "" },
                { id: 5, titulo: 'Mácula', label: '', derecho: datosPausa.fond_macula_od, izquierdo: datosPausa.fond_macula_oi, valor: "" },
            ])

            setText3([
                { id: '1', label: 'OD', k1: datosPausa.queraODK1, eje1: datosPausa.queraODEje1, k2: datosPausa.queraODK2, eje2: datosPausa.queraODEje2 },
                { id: '2', label: 'OI', k1: datosPausa.queraOIK1, eje1: datosPausa.queraOIEje1, k2: datosPausa.queraOIK2, eje2: datosPausa.queraOIEje2 },
            ])

            setText61([
                { id: 1, ojoi: datosPausa.gonioscopia_grado_angulo1oi, label: "OI" },
                { id: 2, ojoi: datosPausa.gonioscopia_grado_angulo2oi, label: "OI" },
                { id: 3, ojoi: datosPausa.gonioscopia_grado_angulo3oi, label: "OI" },
                { id: 4, ojoi: datosPausa.gonioscopia_grado_angulo4oi, label: "OI" },
            ])

            setText62([
                { id: 1, ojod: datosPausa.gonioscopia_grado_angulo1od, label: "OD" },
                { id: 2, ojod: datosPausa.gonioscopia_grado_angulo2od, label: "OD" },
                { id: 3, ojod: datosPausa.gonioscopia_grado_angulo3od, label: "OD" },
                { id: 4, ojod: datosPausa.gonioscopia_grado_angulo4od, label: "OD" },
            ])

            setText7([
                { id: 1, label: 'Observaciones de Gonioscopía', gionocopia: datosPausa.obs_gonioscopia },
            ])

            setText4([
                { id: 'ojoDer', label: 'Ojo Derecho', valor: datosPausa.campo_visual_od },
                { id: 'ojoIzqu', label: 'Ojo Izquierdo', valor: datosPausa.campo_visual_oi },
            ])

            setDiagnosticos([
                ...datosPausa.diagnosticos
            ])

            setDiagnosticoPrioridad([
                ...datosPausa.diagnosticoPrioridad
            ])

            setText9([
                { id: 1, titulo: 'Tratamiento', label: 'Tratamiento', valor: datosPausa.tratamiento },
                { id: 2, titulo: 'Evolucion', label: 'Evolución', valor: datosPausa.evolucion },
            ])

            setRecetas([
                ...datosPausa.recetas
            ])

        }
    }, [datosPausa, drawerOpen])

    useEffect(() => {
        console.log(drawerOpen.item.datosUsuario.Nro_DocIdenti)
    }, [drawerOpen])

    // useEffect(() => {
    //     if (drawerOpen.item.datosPausa[0].datos !== null && drawerOpen.item.datosPausa[0].datos !== undefined) {
    //         setDatosPausa(drawerOpen.item.datosPausa[0].datos)
    //     }
    // }, [drawerOpen])


    // useEffect(() => {

    //     if (datosPausa !== null) {
    //         console.log(datosPausa.examen_fisico)
    //         setText1([
    //             { id: 'anteExamenFisico', label: "Antencedentes", anteExamenFisico: datosPausa.examen_fisico },
    //             { id: 'avsc', label: 'AV SC', derecho: datosPausa.od_avsc, izquierdo: datosPausa.oi_avsc },
    //             { id: 'avph', label: 'AV PH', derecho: '', izquierdo: '' },
    //             { id: 'avcsc', label: 'AV CSC', derecho: '', izquierdo: '' },
    //             { id: 'avcc', label: 'AV CC', derecho: datosPausa.od_avcc, izquierdo: datosPausa.oi_avcc },
    //             { id: 'presion', label: '(mmHg)', derecho: datosPausa.od_tension_ocular, izquierdo: datosPausa.oi_tension_ocular },
    //             { id: 'paquimetria', label: '(µ)', derecho: datosPausa.od_paqui, izquierdo: datosPausa.oi_paqui },
    //             { id: 'pupilas', label: 'Valoración de Pupilas', derecho: '', izquierdo: '' },
    //             { id: 'colores', label: 'Visión de Colores', derecho: '', izquierdo: '' },
    //         ])

    //         setText2([
    //             { id: 'autoreflexion', label: "Auto Refracción", labe1: "OD", label2: "OI", tipo1: 'Autoreflexión', tipo2: '', esf1: datosPausa.auto_ref_od_esf, esf2: datosPausa.auto_ref_oi_esf, cil1: datosPausa.auto_ref_od_cil, cil2: datosPausa.auto_ref_oi_cil, x1: datosPausa.auto_ref_od_x, x2: datosPausa.auto_ref_oi_x, rec1: datosPausa.auto_ref_od_rec, rec2: datosPausa.auto_ref_oi_rec, valor: "" },
    //             { id: 'lejos', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: datosPausa.l_od_esf, esf2: datosPausa.l_oi_esf, cil1: datosPausa.l_od_cil, cil2: datosPausa.l_oi_cil, x1: datosPausa.l_od_x, x2: datosPausa.l_oi_x, rec1: datosPausa.l_od_rec, rec2: datosPausa.l_oi_rec, comentarioLejos: "", valor: "" },
    //             { id: 'cerca', label: `Cerca`, label0: "ADD", labe1: "OD", label2: "OI", tipo1: 'Cerca', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'add', label: "CERCA ADD", labe1: "OD", label2: "OI", tipo1: 'ADD', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'mediaDistancia', label: "Media Distancia", labe1: "OD", label2: "OI", tipo1: 'Media Distancia', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'refraccion', label: "Refracción Cicloplégica", labe1: "OD", label2: "OI", tipo1: 'Refracción Cicloplégica', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'gafas', label: "Gafas", labe1: "OD", label2: "OI", tipo1: 'Gafas', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'lentesContacto', label: "Lentes de contaccto", labe1: "OD", label2: "OI", tipo1: 'Lentes de contaccto', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
    //             { id: 'lejosObjetiva', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" }
    //         ])

    //     }
    // }, [drawerOpen])



    const [vezConsulta, setVezConsulta] = useState([{ value: '01', label: '1° Vez', active: true }, { value: '02', label: 'Continuador', active: false }])
    const [mediciones, setMediciones] = useState([{
        tension_arterial_maxima: '',
        tension_arterial_minima: '',
        peso: '',
        talla: '',
        temperatura: '',
        f_card: '',
        f_resp: '',
        sato: '',
        hgt: ''
    }])
    const [mostrarMedicion, setMostrarMedicion] = useState(false)
    const [tabs, setTabs] = useState([{ value: '02', label: 'Consulta', active: true }, { value: '01', label: 'Antecedentes', active: false }])
    const handleClickRadio = (e) => {
        setVezConsulta(x => x.reduce((arr, item) => {
            arr.push({ ...item, active: item.value === e.target.value && true })
            return arr
        }, []))
    }
    const handleMediciones = (id, value) => {
        setMediciones(x => x.reduce((arr, item) => {
            arr.push({ ...item, [id]: value })
            return arr
        }, []))
    }

    const [text1, setText1] = useState([
        { id: 'anteExamenFisico', label: "Antencedentes", anteExamenFisico: '' },
        { id: 'avsc', label: 'AV SC', derecho: '', izquierdo: '' },
        { id: 'avph', label: 'AV PH', derecho: '', izquierdo: '' },
        { id: 'avcsc', label: 'AV CSC', derecho: '', izquierdo: '' },
        { id: 'avcc', label: 'AV CC', derecho: '', izquierdo: '' },
        { id: 'presion', label: '(mmHg)', derecho: '', izquierdo: '' },
        { id: 'paquimetria', label: '(µ)', derecho: '', izquierdo: '' },
        { id: 'pupilas', label: 'Valoración de Pupilas', derecho: '', izquierdo: '' },
        { id: 'colores', label: 'Visión de Colores', derecho: '', izquierdo: '' },
    ])

    const handleDatosTextField = (id, valor, key) => {
        setText1(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text2, setText2] = useState([
        { id: 'autoreflexion', label: "Auto Refracción", labe1: "OD", label2: "OI", tipo1: 'Autoreflexión', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "", valor: "" },
        { id: 'lejos', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "", comentarioLejos: "", valor: "" },
        { id: 'add', label: "CERCA ADD", labe1: "OD", label2: "OI", tipo1: 'ADD', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'cerca', label: `Cerca`, label0: "ADD", labe1: "OD", label2: "OI", tipo1: 'Cerca', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'mediaDistancia', label: "Media Distancia", labe1: "OD", label2: "OI", tipo1: 'Media Distancia', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'refraccion', label: "Refracción Cicloplégica", labe1: "OD", label2: "OI", tipo1: 'Refracción Cicloplégica', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'gafas', label: "Gafas", labe1: "OD", label2: "OI", tipo1: 'Gafas', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'lentesContacto', label: "Lentes de contaccto", labe1: "OD", label2: "OI", tipo1: 'Lentes de contaccto', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" },
        { id: 'lejosObjetiva', label: "Lejos", labe1: "OD", label2: "OI", tipo1: 'Lejos', tipo2: '', esf1: '', esf2: '', cil1: '', cil2: '', x1: '', x2: '', rec1: "", rec2: "" }
    ])

    const handleDatosTextField2 = (id, valor, key) => {

        setText2(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text3, setText3] = useState([
        { id: '1', label: 'OD', k1: '', eje1: '', k2: "", eje2: "" },
        { id: '2', label: 'OI', k1: '', eje1: '', k2: "", eje2: "" },
    ])

    const handleDatosTextField3 = (id, valor, key) => {

        setText3(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text4, setText4] = useState([
        { id: 'ojoDer', label: 'Ojo Derecho', valor: '' },
        { id: 'ojoIzqu', label: 'Ojo Izquierdo', valor: '' },
    ])

    const handleDatosTextField4 = (id, valor, key) => {

        setText4(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text5, setText5] = useState([

        { id: 1, ojoi: "", label: "OI" },
        { id: 2, ojoi: "", label: "OI" },
        { id: 3, ojoi: "", label: "OI" },
        { id: 4, ojoi: "", label: "OI" },
        { id: 5, ojoi: "", label: "OI" },
        { id: 6, ojoi: "", label: "OI" },
        { id: 7, ojoi: "", label: "OI" },
        { id: 8, ojoi: "", label: "OI" },
        { id: 9, ojoi: "", label: "OI" }
        ,


        { id: 10, ojod: "", label: "OD" },
        { id: 11, ojod: "", label: "OD" },
        { id: 12, ojod: "", label: "OD" },
        { id: 13, ojod: "", label: "OD" },
        { id: 14, ojod: "", label: "OD" },
        { id: 15, ojod: "", label: "OD" },
        { id: 16, ojod: "", label: "OD" },
        { id: 17, ojod: "", label: "OD" },
        { id: 18, ojod: "", label: "OD" }

    ])

    const handleDatosTextField5 = (id, valor, key) => {
        setText5(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text61, setText61] = useState([
        { id: 1, ojoi: "", label: "OI" },
        { id: 2, ojoi: "", label: "OI" },
        { id: 3, ojoi: "", label: "OI" },
        { id: 4, ojoi: "", label: "OI" },
    ])

    const handleDatosTextField61 = (id, valor, key) => {
        setText61(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }
    const [text62, setText62] = useState([
        { id: 1, ojod: "", label: "OD" },
        { id: 2, ojod: "", label: "OD" },
        { id: 3, ojod: "", label: "OD" },
        { id: 4, ojod: "", label: "OD" },
    ])

    const handleDatosTextField62 = (id, valor, key) => {
        setText62(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text7, setText7] = useState([
        { id: 1, label: 'Observaciones de Gonioscopía', gionocopia: "" },
    ])

    const handleDatosTextField7 = (id, valor, key) => {
        setText7(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text8, setText8] = useState([
        { id: 0, titulo: 'Conjuntiva', label: '', izquierdo: "", derecho: "", valor: "" },
        { id: 1, titulo: 'Córnea', label: '', izquierdo: "", derecho: "", valor: "" },
        { id: 2, titulo: 'Cámara Anterior', label: '', izquierdo: "", derecho: "", valor: "" },
        { id: 3, titulo: 'Iris y Pupila', label: '', izquierdo: "", derecho: "", valor: "" },
        { id: 4, titulo: 'Cristalino', label: '', izquierdo: "", derecho: "", valor: "" },
        { id: 5, titulo: 'Vítreo', label: '', izquierdo: "", derecho: "", valor: "" },
    ])

    const handleDatosTextField8 = (id, valor, key) => {
        setText8(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text9, setText9] = useState([
        { id: 1, titulo: 'Tratamiento', label: 'Tratamiento', valor: "" },
        { id: 2, titulo: 'Evolucion', label: 'Evolución', valor: "" },
    ])

    const handleDatosTextField9 = (id, valor, key) => {
        setText9(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }

    const [text10, setText10] = useState([
        { id: 1, titulo: 'Papila', label: '', derecho: "", izquierdo: "", valor: "" },
        { id: 2, titulo: 'Vasos Arteriales', label: '', derecho: "", izquierdo: "", valor: "" },
        { id: 3, titulo: 'Vasos Venosos', label: '', derecho: "", izquierdo: "", valor: "" },
        { id: 4, titulo: 'Retina', label: '', derecho: "", izquierdo: "", valor: "" },
        { id: 5, titulo: 'Mácula', label: '', derecho: "", izquierdo: "", valor: "" },
    ])

    const handleDatosTextField10 = (id, valor, key) => {
        setText10(x => x.reduce((arr, item) => {
            if (item.id === id) {
                arr.push({
                    ...item, [key]: valor
                })
            } else {
                arr.push(item)
            }
            return arr
        }, []))
    }



    const [mostrarReceta, setMostrarReceta] = useState(false)
    const [recetas, setRecetas] = useState([])
    const [selected, setSelected] = useState(null)
    const [valores, setValores] = useState('')
    const [array, setArray] = useState([])

    const removeRecetas = (id) => {
        setRecetas(x => x.filter(y => y.medicamento.id !== id))
    }
    const addRecetas = (item) => {
        setRecetas(x => [...x, item])
    }

    let inputRef;

    const [diagnosticos, setDiagnosticos] = useState([])
    const [diagnosticoPrioridad, setDiagnosticoPrioridad] = useState([])

    const addDiagnostico = () => {
        if (selected !== null) {
            if (diagnosticos.find(x => x.id === selected.id) === undefined) {
                setDiagnosticoPrioridad([...diagnosticoPrioridad, selected.id])
                setDiagnosticos([...diagnosticos, { ...selected }])

            } else {
                enqueueSnackbar('Ya agrego un diagnosticos igual.', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom
                })
            }

        } else {
            enqueueSnackbar('Debe seleccionar un diagnóstico', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom
            })
        }
    }

    useEffect(() => {
        console.log(diagnosticos)
    }, [diagnosticos])
    useEffect(() => {
        console.log(diagnosticoPrioridad)
    }, [diagnosticoPrioridad])
    useEffect(() => {
        console.log(recetas)
    }, [recetas])

    const changedDiagnosticoPrioridad = (id) => {
        let existe = diagnosticoPrioridad.findIndex(x => x === id)
        if (existe < 0) {
            setDiagnosticoPrioridad(x => [...x, id])

        } else {
            setDiagnosticoPrioridad(x => x.filter(y => y !== id))
        }
    }
    const removeDiagnostico = (id) => {
        setDiagnosticos(x => x.filter(y => y.id !== id))
        setDiagnosticoPrioridad(x => x.filter(y => y !== id))
    }

    const handleChanged = (value) => {
        setValores(value === null ? '' : value.label);
        setSelected(value)
    }


    useEffect(() => {
        const getDatos = async (query) => {
            try {
                const response = await axios.get(`http://200.121.91.211:4001/diagnosticos/${query}`)
                setArray(response.data.reduce((arr, item) => {
                    arr.push({ id: item.id, label: item.label })
                    return arr
                }, []))
            } catch (e) {
                console.log(e);
            }

        }

        if (valores.length >= 3) {
            getDatos(valores)
        } else {
            setArray([])
        }

    }, [valores])


    const handleGuardarOftalmologica = async () => {
        // let datosOftalmo = []

        // if (drawerOpen.item.datosPausa !== undefined) {
        //     drawerOpen.item.setMostrarPausa(0)
        // }

        let datosOftalmo2 = {}

        // datosOftalmo.push(text)
        // datosOftalmo.push(text1)
        // datosOftalmo.push(text8)
        // datosOftalmo.push(text2)
        // datosOftalmo.push(text3)
        // datosOftalmo.push(text4)
        // datosOftalmo.push(text5)
        // datosOftalmo.push(text61)
        // datosOftalmo.push(text62)
        // datosOftalmo.push(text7)
        // datosOftalmo.push(text9)

        // tabla gigante
        datosOftalmo2.motivo_consulta = text[0].text
        datosOftalmo2.examen_fisico = text1[0].anteExamenFisico

        datosOftalmo2.bmcd = text8[0].valor
        datosOftalmo2.bmci = text8[1].valor

        datosOftalmo2.bmc_conjuntiva_d = text8[0].derecho
        datosOftalmo2.bmc_conjuntiva_i = text8[0].izquierdo

        datosOftalmo2.bmc_cornea_d = text8[1].derecho
        datosOftalmo2.bmc_cornea_i = text8[1].izquierdo

        datosOftalmo2.bmc_corneaAnt_d = text8[2].derecho
        datosOftalmo2.bmc_corneaAnt_i = text8[2].izquierdo

        datosOftalmo2.bmc_irisPup_d = text8[3].derecho
        datosOftalmo2.bmc_irisPup_i = text8[3].izquierdo

        datosOftalmo2.bmc_cristalino_d = text8[4].derecho
        datosOftalmo2.bmc_cristalino_i = text8[4].izquierdo

        datosOftalmo2.bmc_vitrio_d = text8[5].derecho
        datosOftalmo2.bmc_vitrio_i = text8[5].izquierdo


        datosOftalmo2.evolucion = text9[1].valor
        datosOftalmo2.tratamiento = text9[0].valor

        datosOftalmo2.refracciones_obs = text2[1].valor

        datosOftalmo2.od_avsc = text1[1].derecho
        datosOftalmo2.oi_avsc = text1[1].izquierdo
        datosOftalmo2.od_avcsc = text1[3].derecho
        datosOftalmo2.oi_avcsc = text1[3].izquierdo
        datosOftalmo2.od_avcc = text1[4].derecho
        datosOftalmo2.oi_avcc = text1[4].izquierdo
        datosOftalmo2.od_tension_ocular = text1[5].derecho
        datosOftalmo2.oi_tension_ocular = text1[5].izquierdo
        datosOftalmo2.od_paqui = text1[6].derecho
        datosOftalmo2.oi_paqui = text1[6].izquierdo
        datosOftalmo2.od_val_pupila = text1[7].derecho
        datosOftalmo2.oi_val_pupila = text1[7].izquierdo
        datosOftalmo2.od_vision_color = text1[8].derecho
        datosOftalmo2.oi_vision_color = text1[8].izquierdo


        datosOftalmo2.gafas_od_esf = text2[5].esf1
        datosOftalmo2.gafas_od_cil = text2[5].cil1
        datosOftalmo2.gafas_od_x = text2[5].x1
        datosOftalmo2.gafas_od_rec = text2[5].rec1
        datosOftalmo2.gafas_oi_esf = text2[5].esf2
        datosOftalmo2.gafas_oi_cil = text2[5].cil2
        datosOftalmo2.gafas_oi_x = text2[5].x2
        datosOftalmo2.gafas_oi_rec = text2[5].rec2

        datosOftalmo2.l_od_esf = text2[1].esf1
        datosOftalmo2.l_od_cil = text2[1].cil1
        datosOftalmo2.l_od_x = text2[1].x1
        datosOftalmo2.l_od_rec = text2[1].rec1
        datosOftalmo2.l_oi_esf = text2[1].esf2
        datosOftalmo2.l_oi_cil = text2[1].cil2
        datosOftalmo2.l_oi_x = text2[1].x2
        datosOftalmo2.l_oi_rec = text2[1].rec2

        datosOftalmo2.c_od_esf = text2[3].esf1
        datosOftalmo2.c_od_cil = text2[3].cil1
        datosOftalmo2.c_od_x = text2[3].x1
        datosOftalmo2.c_od_rec = text2[3].rec1
        datosOftalmo2.c_oi_esf = text2[3].esf2
        datosOftalmo2.c_oi_cil = text2[3].cil2
        datosOftalmo2.c_oi_x = text2[3].x2
        datosOftalmo2.c_oi_rec = text2[3].rec2

        datosOftalmo2.md_od_esf = text2[4].esf1
        datosOftalmo2.md_od_cil = text2[4].cil1
        datosOftalmo2.md_od_x = text2[4].x1
        datosOftalmo2.md_od_rec = text2[4].rec1
        datosOftalmo2.md_oi_esf = text2[4].esf2
        datosOftalmo2.md_oi_cil = text2[4].cil2
        datosOftalmo2.md_oi_x = text2[4].x2
        datosOftalmo2.md_oi_rec = text2[4].rec2


        datosOftalmo2.obs_gonioscopia = text7[0].gionocopia


        datosOftalmo2.campo_visual_od = text4[0].valor
        datosOftalmo2.campo_visual_oi = text4[1].valor


        datosOftalmo2.ref_ciclo_od_esf = text2[6].esf1
        datosOftalmo2.ref_ciclo_od_cil = text2[6].cil1
        datosOftalmo2.ref_ciclo_od_x = text2[6].x1
        datosOftalmo2.ref_ciclo_od_rec = text2[6].rec1
        datosOftalmo2.ref_ciclo_oi_esf = text2[6].esf2
        datosOftalmo2.ref_ciclo_oi_cil = text2[6].cil2
        datosOftalmo2.ref_ciclo_oi_x = text2[6].x2
        datosOftalmo2.ref_ciclo_oi_rec = text2[6].rec2

        datosOftalmo2.auto_ref_od_esf = text2[0].esf1
        datosOftalmo2.auto_ref_od_cil = text2[0].cil1
        datosOftalmo2.auto_ref_od_x = text2[0].x1
        datosOftalmo2.auto_ref_od_rec = text2[0].rec1
        datosOftalmo2.auto_ref_oi_esf = text2[0].esf2
        datosOftalmo2.auto_ref_oi_cil = text2[0].cil2
        datosOftalmo2.auto_ref_oi_x = text2[0].x2
        datosOftalmo2.auto_ref_oi_rec = text2[0].rec2

        datosOftalmo2.fondoscopia_od = text10[0].valor
        datosOftalmo2.fondoscopia_oi = text10[1].valor




        datosOftalmo2.od_avph = text1[2].derecho
        datosOftalmo2.oi_avph = text1[2].izquierdo

        datosOftalmo2.add_od_esf = text2[2].esf1
        datosOftalmo2.add_od_cil = text2[2].cil1
        datosOftalmo2.add_od_x = text2[2].x1
        datosOftalmo2.add_od_rec = text2[2].rec1
        datosOftalmo2.add_oi_esf = text2[2].esf2
        datosOftalmo2.add_oi_cil = text2[2].cil2
        datosOftalmo2.add_oi_x = text2[2].x2
        datosOftalmo2.add_oi_rec = text2[2].rec2

        datosOftalmo2.lentes_contacto_od_esf = text2[7].esf1
        datosOftalmo2.lentes_contacto_od_cil = text2[7].cil1
        datosOftalmo2.lentes_contacto_od_x = text2[7].x1
        datosOftalmo2.lentes_contacto_od_rec = text2[7].rec1
        datosOftalmo2.lentes_contacto_oi_esf = text2[7].esf2
        datosOftalmo2.lentes_contacto_oi_cil = text2[7].cil2
        datosOftalmo2.lentes_contacto_oi_x = text2[7].x2
        datosOftalmo2.lentes_contacto_oi_rec = text2[7].rec2

        datosOftalmo2.lejosObjetiva_od_esf = text2[8].esf1
        datosOftalmo2.lejosObjetiva_od_cil = text2[8].cil1
        datosOftalmo2.lejosObjetiva_od_x = text2[8].x1
        datosOftalmo2.lejosObjetiva_od_rec = text2[8].rec1
        datosOftalmo2.lejosObjetiva_oi_esf = text2[8].esf2
        datosOftalmo2.lejosObjetiva_oi_cil = text2[8].cil2
        datosOftalmo2.lejosObjetiva_oi_x = text2[8].x2
        datosOftalmo2.lejosObjetiva_oi_rec = text2[8].rec2

        datosOftalmo2.fond_pupila_od = text10[0].derecho
        datosOftalmo2.fond_pupila_oi = text10[0].izquierdo
        datosOftalmo2.fond_vasosArt_od = text10[1].derecho
        datosOftalmo2.fond_vasosArt_oi = text10[1].izquierdo
        datosOftalmo2.fond_VasosVen_od = text10[2].derecho
        datosOftalmo2.fond_VasosVen_oi = text10[2].izquierdo
        datosOftalmo2.fond_retina_od = text10[3].derecho
        datosOftalmo2.fond_retina_oi = text10[3].izquierdo
        datosOftalmo2.fond_macula_od = text10[4].derecho
        datosOftalmo2.fond_macula_oi = text10[4].izquierdo

        // balances
        datosOftalmo2.balancesOjoOi = text5[0].label
        datosOftalmo2.balance1oi = text5[0].ojoi
        datosOftalmo2.balance2oi = text5[1].ojoi
        datosOftalmo2.balance3oi = text5[2].ojoi
        datosOftalmo2.balance4oi = text5[3].ojoi
        datosOftalmo2.balance5oi = text5[4].ojoi
        datosOftalmo2.balance6oi = text5[5].ojoi
        datosOftalmo2.balance7oi = text5[6].ojoi
        datosOftalmo2.balance8oi = text5[7].ojoi
        datosOftalmo2.balance9oi = text5[8].ojoi

        datosOftalmo2.balancesOjoOd = text5[9].label
        datosOftalmo2.balance1od = text5[9].ojod
        datosOftalmo2.balance2od = text5[10].ojod
        datosOftalmo2.balance3od = text5[11].ojod
        datosOftalmo2.balance4od = text5[12].ojod
        datosOftalmo2.balance5od = text5[13].ojod
        datosOftalmo2.balance6od = text5[14].ojod
        datosOftalmo2.balance7od = text5[15].ojod
        datosOftalmo2.balance8od = text5[16].ojod
        datosOftalmo2.balance9od = text5[17].ojod

        // gonioscopia
        datosOftalmo2.gonioscopiaOjoOi = text61[0].label
        datosOftalmo2.gonioscopia_grado_angulo1oi = text61[0].ojoi
        datosOftalmo2.gonioscopia_grado_angulo2oi = text61[1].ojoi
        datosOftalmo2.gonioscopia_grado_angulo3oi = text61[2].ojoi
        datosOftalmo2.gonioscopia_grado_angulo4oi = text61[3].ojoi

        datosOftalmo2.gonioscopiaOjoOd = text62[0].label
        datosOftalmo2.gonioscopia_grado_angulo1od = text62[0].ojod
        datosOftalmo2.gonioscopia_grado_angulo2od = text62[1].ojod
        datosOftalmo2.gonioscopia_grado_angulo3od = text62[2].ojod
        datosOftalmo2.gonioscopia_grado_angulo4od = text62[3].ojod

        // queratometria
        datosOftalmo2.queraODOjo = text3[0].label
        datosOftalmo2.queraODK1 = text3[0].k1
        datosOftalmo2.queraODEje1 = text3[0].eje1
        datosOftalmo2.queraODK2 = text3[0].k2
        datosOftalmo2.queraODEje2 = text3[0].eje2

        datosOftalmo2.queraOIOjo = text3[1].label
        datosOftalmo2.queraOIK1 = text3[1].k1
        datosOftalmo2.queraOIEje1 = text3[1].eje1
        datosOftalmo2.queraOIK2 = text3[1].k2
        datosOftalmo2.queraOIEje2 = text3[1].eje2

        datosOftalmo2.medicion = mediciones[0]
        datosOftalmo2.documento = user.datos.numero_documento
        datosOftalmo2.persona = drawerOpen.item.datosUsuario.Nro_DocIdenti
        datosOftalmo2.turno = id
        datosOftalmo2.diagnosticos = diagnosticos
        datosOftalmo2.diagnosticoPrioridad = diagnosticoPrioridad
        datosOftalmo2.recetas = recetas
        datosOftalmo2.vezConsulta = vezConsulta

        // console.log(datosOftalmo)
        console.log(datosOftalmo2)
        console.log(datosOftalmo2.turno)

        if (diagnosticos.length > 0 || diagnosticoPrioridad > 0) {

            const rpta1 = await confirmSweetAlert(`${user.datos.ape_paterno} ${user.datos.ape_materno} ${user.datos.nombres}`, `¿Está seguro(a) que desea guardar la consulta?`, 'warning', true)

            try {
                if (rpta1) {
                    const rpta = await axios.post('http://132.157.160.67:4001/insertConsultaBasicaAmbulatoriaOftalmologia', datosOftalmo2)
                    console.log(rpta.data)
                }
                enqueueSnackbar('Consulta Guardada con Éxito', {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 3000
                })



                const rpta22 = await axios.post(`http://200.121.91.211:4001/borrarPausa`, {
                    turno: datosOftalmo2.turno,
                })

                console.log(rpta22.data)

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
                console.log("Los datos enviados son: ", rpta1, datosOftalmo2)
            } catch (error) {
                console.log('error al enviar la data: ', error)
            }



        } else {
            enqueueSnackbar('Debe agregar el diagnóstico', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 3000
            })
        }



    }

    const guardarPausa = async () => {
        const rpta = await confirmSweetAlert(`${user.datos.ape_paterno} ${user.datos.ape_materno} ${user.datos.nombres}`, `Esta seguro que desea pausar la consulta`, 'warning', true)
        if (rpta) {
            // let obj = {
            //     vezConsulta,
            //     mediciones,
            //     text,
            //     diagnosticos,
            //     diagnosticoPrioridad,
            //     recetas,
            //     estudios,
            //     hospitaliza,
            //     selected,
            //     valores,
            //     mostrar,
            //     mostrarReceta,
            //     noCita
            // }

            let datosOftalmo2 = {}

            // tabla gigante
            datosOftalmo2.motivo_consulta = text[0].text
            datosOftalmo2.examen_fisico = text1[0].anteExamenFisico

            datosOftalmo2.bmcd = text8[0].valor
            datosOftalmo2.bmci = text8[1].valor

            datosOftalmo2.bmc_conjuntiva_d = text8[0].derecho
            datosOftalmo2.bmc_conjuntiva_i = text8[0].izquierdo

            datosOftalmo2.bmc_cornea_d = text8[1].derecho
            datosOftalmo2.bmc_cornea_i = text8[1].izquierdo

            datosOftalmo2.bmc_corneaAnt_d = text8[2].derecho
            datosOftalmo2.bmc_corneaAnt_i = text8[2].izquierdo

            datosOftalmo2.bmc_irisPup_d = text8[3].derecho
            datosOftalmo2.bmc_irisPup_i = text8[3].izquierdo

            datosOftalmo2.bmc_cristalino_d = text8[4].derecho
            datosOftalmo2.bmc_cristalino_i = text8[4].izquierdo

            datosOftalmo2.bmc_vitrio_d = text8[5].derecho
            datosOftalmo2.bmc_vitrio_i = text8[5].izquierdo


            datosOftalmo2.evolucion = text9[1].valor
            datosOftalmo2.tratamiento = text9[0].valor

            datosOftalmo2.refracciones_obs = text2[1].valor

            datosOftalmo2.od_avsc = text1[1].derecho
            datosOftalmo2.oi_avsc = text1[1].izquierdo
            datosOftalmo2.od_avcsc = text1[3].derecho
            datosOftalmo2.oi_avcsc = text1[3].izquierdo
            datosOftalmo2.od_avcc = text1[4].derecho
            datosOftalmo2.oi_avcc = text1[4].izquierdo
            datosOftalmo2.od_tension_ocular = text1[5].derecho
            datosOftalmo2.oi_tension_ocular = text1[5].izquierdo
            datosOftalmo2.od_paqui = text1[6].derecho
            datosOftalmo2.oi_paqui = text1[6].izquierdo
            datosOftalmo2.od_val_pupila = text1[7].derecho
            datosOftalmo2.oi_val_pupila = text1[7].izquierdo
            datosOftalmo2.od_vision_color = text1[8].derecho
            datosOftalmo2.oi_vision_color = text1[8].izquierdo

            datosOftalmo2.gafas_od_esf = text2[5].esf1
            datosOftalmo2.gafas_od_cil = text2[5].cil1
            datosOftalmo2.gafas_od_x = text2[5].x1
            datosOftalmo2.gafas_od_rec = text2[5].rec1
            datosOftalmo2.gafas_oi_esf = text2[5].esf2
            datosOftalmo2.gafas_oi_cil = text2[5].cil2
            datosOftalmo2.gafas_oi_x = text2[5].x2
            datosOftalmo2.gafas_oi_rec = text2[5].rec2

            datosOftalmo2.l_od_esf = text2[1].esf1
            datosOftalmo2.l_od_cil = text2[1].cil1
            datosOftalmo2.l_od_x = text2[1].x1
            datosOftalmo2.l_od_rec = text2[1].rec1
            datosOftalmo2.l_oi_esf = text2[1].esf2
            datosOftalmo2.l_oi_cil = text2[1].cil2
            datosOftalmo2.l_oi_x = text2[1].x2
            datosOftalmo2.l_oi_rec = text2[1].rec2

            datosOftalmo2.c_od_esf = text2[3].esf1
            datosOftalmo2.c_od_cil = text2[3].cil1
            datosOftalmo2.c_od_x = text2[3].x1
            datosOftalmo2.c_od_rec = text2[3].rec1
            datosOftalmo2.c_oi_esf = text2[3].esf2
            datosOftalmo2.c_oi_cil = text2[3].cil2
            datosOftalmo2.c_oi_x = text2[3].x2
            datosOftalmo2.c_oi_rec = text2[3].rec2

            datosOftalmo2.md_od_esf = text2[4].esf1
            datosOftalmo2.md_od_cil = text2[4].cil1
            datosOftalmo2.md_od_x = text2[4].x1
            datosOftalmo2.md_od_rec = text2[4].rec1
            datosOftalmo2.md_oi_esf = text2[4].esf2
            datosOftalmo2.md_oi_cil = text2[4].cil2
            datosOftalmo2.md_oi_x = text2[4].x2
            datosOftalmo2.md_oi_rec = text2[4].rec2

            datosOftalmo2.obs_gonioscopia = text7[0].gionocopia

            datosOftalmo2.campo_visual_od = text4[0].valor
            datosOftalmo2.campo_visual_oi = text4[1].valor

            datosOftalmo2.ref_ciclo_od_esf = text2[6].esf1
            datosOftalmo2.ref_ciclo_od_cil = text2[6].cil1
            datosOftalmo2.ref_ciclo_od_x = text2[6].x1
            datosOftalmo2.ref_ciclo_od_rec = text2[6].rec1
            datosOftalmo2.ref_ciclo_oi_esf = text2[6].esf2
            datosOftalmo2.ref_ciclo_oi_cil = text2[6].cil2
            datosOftalmo2.ref_ciclo_oi_x = text2[6].x2
            datosOftalmo2.ref_ciclo_oi_rec = text2[6].rec2

            datosOftalmo2.auto_ref_od_esf = text2[0].esf1
            datosOftalmo2.auto_ref_od_cil = text2[0].cil1
            datosOftalmo2.auto_ref_od_x = text2[0].x1
            datosOftalmo2.auto_ref_od_rec = text2[0].rec1
            datosOftalmo2.auto_ref_oi_esf = text2[0].esf2
            datosOftalmo2.auto_ref_oi_cil = text2[0].cil2
            datosOftalmo2.auto_ref_oi_x = text2[0].x2
            datosOftalmo2.auto_ref_oi_rec = text2[0].rec2

            datosOftalmo2.fondoscopia_od = text10[0].valor
            datosOftalmo2.fondoscopia_oi = text10[1].valor

            datosOftalmo2.od_avph = text1[2].derecho
            datosOftalmo2.oi_avph = text1[2].izquierdo

            datosOftalmo2.add_od_esf = text2[2].esf1
            datosOftalmo2.add_od_cil = text2[2].cil1
            datosOftalmo2.add_od_x = text2[2].x1
            datosOftalmo2.add_od_rec = text2[2].rec1
            datosOftalmo2.add_oi_esf = text2[2].esf2
            datosOftalmo2.add_oi_cil = text2[2].cil2
            datosOftalmo2.add_oi_x = text2[2].x2
            datosOftalmo2.add_oi_rec = text2[2].rec2

            datosOftalmo2.lentes_contacto_od_esf = text2[7].esf1
            datosOftalmo2.lentes_contacto_od_cil = text2[7].cil1
            datosOftalmo2.lentes_contacto_od_x = text2[7].x1
            datosOftalmo2.lentes_contacto_od_rec = text2[7].rec1
            datosOftalmo2.lentes_contacto_oi_esf = text2[7].esf2
            datosOftalmo2.lentes_contacto_oi_cil = text2[7].cil2
            datosOftalmo2.lentes_contacto_oi_x = text2[7].x2
            datosOftalmo2.lentes_contacto_oi_rec = text2[7].rec2

            datosOftalmo2.lejosObjetiva_od_esf = text2[8].esf1
            datosOftalmo2.lejosObjetiva_od_cil = text2[8].cil1
            datosOftalmo2.lejosObjetiva_od_x = text2[8].x1
            datosOftalmo2.lejosObjetiva_od_rec = text2[8].rec1
            datosOftalmo2.lejosObjetiva_oi_esf = text2[8].esf2
            datosOftalmo2.lejosObjetiva_oi_cil = text2[8].cil2
            datosOftalmo2.lejosObjetiva_oi_x = text2[8].x2
            datosOftalmo2.lejosObjetiva_oi_rec = text2[8].rec2

            datosOftalmo2.fond_pupila_od = text10[0].derecho
            datosOftalmo2.fond_pupila_oi = text10[0].izquierdo
            datosOftalmo2.fond_vasosArt_od = text10[1].derecho
            datosOftalmo2.fond_vasosArt_oi = text10[1].izquierdo
            datosOftalmo2.fond_VasosVen_od = text10[2].derecho
            datosOftalmo2.fond_VasosVen_oi = text10[2].izquierdo
            datosOftalmo2.fond_retina_od = text10[3].derecho
            datosOftalmo2.fond_retina_oi = text10[3].izquierdo
            datosOftalmo2.fond_macula_od = text10[4].derecho
            datosOftalmo2.fond_macula_oi = text10[4].izquierdo

            // balances
            datosOftalmo2.balancesOjoOi = text5[0].label
            datosOftalmo2.balance1oi = text5[0].ojoi
            datosOftalmo2.balance2oi = text5[1].ojoi
            datosOftalmo2.balance3oi = text5[2].ojoi
            datosOftalmo2.balance4oi = text5[3].ojoi
            datosOftalmo2.balance5oi = text5[4].ojoi
            datosOftalmo2.balance6oi = text5[5].ojoi
            datosOftalmo2.balance7oi = text5[6].ojoi
            datosOftalmo2.balance8oi = text5[7].ojoi
            datosOftalmo2.balance9oi = text5[8].ojoi

            datosOftalmo2.balancesOjoOd = text5[9].label
            datosOftalmo2.balance1od = text5[9].ojod
            datosOftalmo2.balance2od = text5[10].ojod
            datosOftalmo2.balance3od = text5[11].ojod
            datosOftalmo2.balance4od = text5[12].ojod
            datosOftalmo2.balance5od = text5[13].ojod
            datosOftalmo2.balance6od = text5[14].ojod
            datosOftalmo2.balance7od = text5[15].ojod
            datosOftalmo2.balance8od = text5[16].ojod
            datosOftalmo2.balance9od = text5[17].ojod

            // gonioscopia
            datosOftalmo2.gonioscopiaOjoOi = text61[0].label
            datosOftalmo2.gonioscopia_grado_angulo1oi = text61[0].ojoi
            datosOftalmo2.gonioscopia_grado_angulo2oi = text61[1].ojoi
            datosOftalmo2.gonioscopia_grado_angulo3oi = text61[2].ojoi
            datosOftalmo2.gonioscopia_grado_angulo4oi = text61[3].ojoi

            datosOftalmo2.gonioscopiaOjoOd = text62[0].label
            datosOftalmo2.gonioscopia_grado_angulo1od = text62[0].ojod
            datosOftalmo2.gonioscopia_grado_angulo2od = text62[1].ojod
            datosOftalmo2.gonioscopia_grado_angulo3od = text62[2].ojod
            datosOftalmo2.gonioscopia_grado_angulo4od = text62[3].ojod

            // queratometria
            datosOftalmo2.queraODOjo = text3[0].label
            datosOftalmo2.queraODK1 = text3[0].k1
            datosOftalmo2.queraODEje1 = text3[0].eje1
            datosOftalmo2.queraODK2 = text3[0].k2
            datosOftalmo2.queraODEje2 = text3[0].eje2

            datosOftalmo2.queraOIOjo = text3[1].label
            datosOftalmo2.queraOIK1 = text3[1].k1
            datosOftalmo2.queraOIEje1 = text3[1].eje1
            datosOftalmo2.queraOIK2 = text3[1].k2
            datosOftalmo2.queraOIEje2 = text3[1].eje2

            datosOftalmo2.medicion = mediciones[0]
            datosOftalmo2.documento = user.datos.numero_documento
            datosOftalmo2.persona = drawerOpen.item.datosUsuario.Nro_DocIdenti
            datosOftalmo2.turno = id
            datosOftalmo2.diagnosticos = diagnosticos
            datosOftalmo2.diagnosticoPrioridad = diagnosticoPrioridad
            datosOftalmo2.recetas = recetas
            datosOftalmo2.vezConsulta = vezConsulta

            // console.log(datosOftalmo)
            console.log(datosOftalmo2)
            console.log(datosOftalmo2.turno)

            const rpta22 = await axios.post(`http://200.121.91.211:4001/BotonPausa`, {
                turno: datosOftalmo2.turno,
                datos: { ...datosOftalmo2 }
            })

            if (rpta22.status === 200) {
                enqueueSnackbar("Pausado correctamente", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 1000
                })
                setTimeout(() => {
                    window.location.reload(true);
                }, 1500)
            }

        }
    }



    return (
        <>

            <Box m={2}>
                <Box>
                    <Grid alignItems="center" justifyContent={"center"} container spacing={1} sx={{ my: 1, pb: 3 }} >
                        <Grid item lg={12}>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        sx={{ mb: 1 }}
                                        value={vezConsulta.find(x => x.active).value}
                                        onChange={(e) => handleClickRadio(e)}
                                    >
                                        {
                                            vezConsulta.map((item) => <FormControlLabel key={item.value} value={item.value} control={<Radio size="small" />} label={item.label} />)
                                        }

                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Divider />
                        </Grid>
                        <Grid item lg={11}>
                            {
                                mostrarMedicion && <ListaMedicion mediciones={mediciones} handleMediciones={handleMediciones} />
                            }

                        </Grid>
                        <Grid item lg={3}>
                            <Button
                                variant="outlined"
                                fullWidth
                                color={mostrarMedicion ? 'secondary' : 'info'}
                                onClick={() => setMostrarMedicion(x => !x)}
                            >
                                {mostrarMedicion ? 'Ocultar ' : 'Mostrar '} signos vitales
                            </Button>
                        </Grid>
                        <Grid item lg={12}>
                            <Divider />
                        </Grid>
                        <Grid item lg={4} sx={{ mt: 1 }}>
                            <TabsGeneral setTabs={setTabs} tabs={tabs} />
                        </Grid>

                        {
                            tabs.find(x => x.active).value === '02' &&
                            <Grid item lg={12} sx={{ mt: -5 }}>
                                <Card>
                                    <CardContent style={{ padding: "20px" }}>

                                        <Grid item lg={12} sx={{ mx: 2 }}>
                                            <ComponenteHTML text={text.find(x => x.id === 'motivo')} handleChangedTextState={handleChangedTextState} title={'Motivo de consulta'} />
                                        </Grid>

                                        <Bloque1 text1={text1} handleDatosTextField={handleDatosTextField} text8={text8} handleDatosTextField8={handleDatosTextField8} />
                                        {/* <Bloque8 text8={text8} handleDatosTextField8={handleDatosTextField8} /> */}
                                        <Bloque2 text2={text2} handleDatosTextField2={handleDatosTextField2} />
                                        <Bloque10 text10={text10} handleDatosTextField10={handleDatosTextField10} />
                                        <Bloque3 text3={text3} handleDatosTextField3={handleDatosTextField3} />
                                        <Bloque6 text61={text61} handleDatosTextField61={handleDatosTextField61} text62={text62} handleDatosTextField62={handleDatosTextField62} text7={text7} handleDatosTextField7={handleDatosTextField7} />
                                        {/* <Bloque7 text7={text7} handleDatosTextField7={handleDatosTextField7} /> */}
                                        <Bloque4 text4={text4} handleDatosTextField4={handleDatosTextField4} />
                                        <Bloque5 style={{ display: "none" }} text5={text5} handleDatosTextField5={handleDatosTextField5} />

                                        <Grid item lg={12} sx={{ mx: 0, mt: 2 }}>
                                            <Typography variant="h4" sx={{ mb: 1 }}><b>Diagnóstico</b></Typography>
                                            <Autocomplete
                                                inputValue={valores}
                                                value={selected}
                                                onChange={(_, value) => handleChanged(value)}
                                                autoHighlight
                                                options={array}
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        onChange={(e) =>
                                                            setValores(e.target.value)
                                                        }
                                                        inputRef={input => {
                                                            inputRef = input;
                                                        }}
                                                        fullWidth
                                                        variant="outlined"
                                                        label={''}
                                                        placeholder={'Seleccione diagnostico ...'}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item lg={12} sx={{ mx: 0, mt: 1 }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    addDiagnostico()
                                                    setValores('')
                                                    setSelected(null)
                                                    inputRef.focus();
                                                }}
                                                sx={{ float: 'right', m: 0.2, mt: 0 }}
                                            >
                                                Agregar Diagnóstico
                                            </Button>
                                        </Grid>
                                        <Grid item lg={12} sx={{ mx: 2 }}>
                                            {diagnosticos.length > 0 && <ListaDiagnostico removeDiagnostico={removeDiagnostico} changedDiagnosticoPrioridad={changedDiagnosticoPrioridad} diagnosticos={diagnosticos} diagnosticoPrioridad={diagnosticoPrioridad} />}
                                        </Grid>

                                        <Box style={{ color: "transparent", marginTop: "-25px" }}>
                                            null
                                        </Box>

                                        <Box style={{ display: "flex", justifyContent: "right", justifyItems: "right", alignContent: "right", alignItems: "right", marginTop: "50px" }}>
                                            <Button

                                                variant="contained"
                                                onClick={() => setMostrarReceta(x => !x)

                                                    //     mostrarComponent({
                                                    //     contenido: 'receta',
                                                    //     estado: true,
                                                    //     size: 'sm',
                                                    //     item: {
                                                    //         datosUsuario: drawerOpen.item.datosUsuario, addRecetas: (item) => addRecetas(item)
                                                    //     }
                                                    // }, 'modalOpen')


                                                }
                                                sx={{ float: 'right', m: 0.2, mt: 2, ml: 5 }}
                                            >
                                                Agregar receta
                                            </Button>
                                        </Box>

                                        
                                        
                                        <Grid item sm={20} xs={20} md={20} lg={20} sx={{ transform: "scale(0.65)" }}>
                                            {mostrarReceta && <ListaReceta removeRecetas={removeRecetas} recetas={recetas} addRecetas={addRecetas} />}
                                        </Grid>

                                        <Divider style={{ marginTop: "10px" }} />

                                        <Bloque9 text9={text9} handleDatosTextField9={handleDatosTextField9} />
                                        <Box style={{ maxWidth: "100%", display: "flex", justifyContent: "center", marginTop: "20px", flexDirection: "column" }}>

                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                color='error'
                                                sx={{ float: 'right', m: 0.2, mt: 4 }}
                                                onClick={guardarPausa}
                                            >
                                                Pausar consulta
                                            </Button>
                                            <Button
                                                variant='contained'
                                                onClick={handleGuardarOftalmologica}
                                                fullWidth
                                                sx={{ float: 'right', m: 0.2, mt: 1 }}
                                            >Finalizar Consulta Oftalmológica
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        }

                        {
                            tabs.find(x => x.active).value === '01' && <Antecedentes />
                        }
                    </Grid>

                </Box>
            </Box>
        </>
    )
}
